import smartSolveApi from './instances/smartsolve';

export const submitMasterSetupRecord = async ({
  clientChanges,
  entityName,
  itemId,
  isDelete = false,
  commandName,
  commandArgument,
  itemCode = '',
}) => {
  try {
    const response = await smartSolveApi.post('/submitmastersetuprecord', {
      itemID: itemId,
      clientChanges,
      entityName,
      isDelete,
      commandName,
      commandArgument,
      itemCode,
    });

    return response.data;
  } catch (e) {
    throw new Error(`submitMasterSetupRecord() failed: ${e}`);
  }
};

export const saveMasterSetupRecord = (
  clientChanges,
  entityName,
  itemId,
  commandName,
  commandArgument
) => submitMasterSetupRecord({ clientChanges, entityName, itemId, commandName, commandArgument });

export const deleteMasterSetupRecord = (entityName, itemId) => {
  return submitMasterSetupRecord({
    clientChanges: [],
    entityName,
    itemId,
    isDelete: true,
    commandName: '',
    commandArgument: '',
  });
};
